@if (uiDefinition) {
  @for (component of uiDefinition.definition; track component) {
    <ng-template #children></ng-template>
  }
} @else {
  <div>
    UiDefinition nicht gefunden.
  </div>
}

<ng-template #noUiDefinitionFound>
  <div>
    UiDefinition nicht gefunden.
  </div>
</ng-template>